import { render, staticRenderFns } from "./thirdOilOrderList.vue?vue&type=template&id=482aa810&scoped=true"
import script from "./thirdOilOrderList.vue?vue&type=script&lang=js"
export * from "./thirdOilOrderList.vue?vue&type=script&lang=js"
import style0 from "./thirdOilOrderList.vue?vue&type=style&index=0&id=482aa810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482aa810",
  null
  
)

export default component.exports